<template>
  <div class="select-label-box">
    <div class="label-select">
      <a-select v-model="labelSelectData.labelKey" @change="labelKeyChange">
        <a-select-option
          v-for="item in labelOptions"
          :key="item.value"
          :value="item.value"
        >
        {{ item.label}}
        </a-select-option>
      </a-select>
    </div>
    <div class="select-label-value">
      <template v-for="item in labelOptions" >
        <component
          :is="`a-${item.type}`"
          v-if="NoSlotComponents.includes(`a-${item.type}`)
            && item.value === labelSelectData.labelKey"
          :key="item.value"
          v-model="labelSelectData.labelValue"
          v-bind="getFormFieldProps(item.type, item.props)"
        />
        <component
          :is="`a-${item.type}`"
          v-else-if="item.value === labelSelectData.labelKey"
          :key="item.value"
          v-model="labelSelectData.labelValue"
          v-bind="getFormFieldProps(item.type, item.props)"
        >
          <template v-if="item.type === FieldsType.SELECT">
            <el-option
              v-for="option in item.options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </template>
        </component>
      </template>
    </div>
  </div>
</template>

<script>

const NoSlotComponents = ['a-date-picker', 'a-cascader'];
const FieldsType = {
  INPUT: 'input',
  SELECT: 'select',
};

export default {
  model: {
    prop: "labelSelectData",
  },
  props: {
    labelOptions: {
      type: Array,
      default: () => [],
    },
    labelSelectData: {
      type: Object,
      default: () => {},
    },
  },
  data(){
    return{
      FieldsType,
      NoSlotComponents,
      defaultFieldsProps: {
        'date-picker': {
          valueFormat: 'YYYY-MM-DD',
        },
      },
    }
  },
  methods:{
    labelKeyChange(){
      this.$emit('update:labelSelectData', this.labelSelectData);
    },
    getFormFieldProps(fieldType, props) {
      return { ...this.defaultFieldsProps[fieldType], ...props };
    },
  },
};
</script>
<style lang="less" scoped>
.select-label-box {
  width: calc(100% + 95px);
  display: flex;
  margin-left: -95px;

  .label-select {
    width: 95px;
  }

  :deep(.el-date-editor.el-input,.el-date-editor.el-input__inner) {
    width: 100%;
  }

  .select-label-value {
    flex: 1;
  }
}
</style>
